import { baseColors, baseUnit, iconSize, spacing, colorTokens, cssVar } from './config'

export const colors = {
  primary: '#3c3854',
  primaryDark: cssVar('surface-primary-dark'),
  pageBackground: cssVar('background'),
  primaryDarker: cssVar('surface-primary-darker'),
  primaryLight: cssVar('surface-primary-light'),
  backgroundLight: cssVar('color-backgroundLight'),
  backgroundMedium: cssVar('color-backgroundMedium'),
  backgroundDark: cssVar('color-backgroundDark'),
  backgroundDarker: cssVar('color-backgroundDarker'),
  ssmCardSkeleton:
    'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 100%)',
  white: '#ffffff',
  foreground: cssVar('text-primary'),
  cardDateText: cssVar('chart-card-date'),
  statusValueGood: cssVar('status-value-good'),
  statusValueBad: cssVar('status-value-bad'),
  gaugeTrack: cssVar('gauge-track'),
  perfAreaFill: cssVar('perf-area-fill'),
  chartAxisText: cssVar('chart-axis-text'),
  chartSeries1: cssVar('chart-series-1'),
  chartSeries2: cssVar('chart-series-2'),
  benchMoreStrict: cssVar('bench-more-strict'),
  chartGrid: cssVar('chart-grid'),
  cta: cssVar('cta'),
  dropdownBorder: cssVar('dropdown-border'),
  dropdownLabel: cssVar('dropdown-label'),
  menuBg: cssVar('menu-bg'),
  menuItemText: cssVar('menu-item-text'),
  menuItemHover: cssVar('menu-item-hover'),
  textSecondary: cssVar('text-secondary'),
  caption: cssVar('caption'),
  textCaption: cssVar('text-caption'),
  mainSecondary: cssVar('main-secondary'),
  strokeSecondary: cssVar('stroke-secondary'),
  strokeTertiary: cssVar('stroke-tertiary'),
  inputError: cssVar('input-error'),
  betaChipInactive: cssVar('beta-chip-inactive'),
  chipActiveBg: cssVar('chip-active-bg'),
  tooltipBg: cssVar('tooltip-bg'),
  modalSurface: cssVar('modal-surface'),
  tooltipShadow: cssVar('tooltip-shadow'),
  buttonHollowHover: cssVar('button-hollow-hover'),
  buttonHollowFocus: cssVar('button-hollow-focus'),
  buttonHollowDisabled: cssVar('button-hollow-disabled'),
  settingsCardBg: cssVar('settings-card-bg'),
  calendarRangeEndpoint: cssVar('calendar-range-endpoint'),
  calendarRangeEndpointHover: cssVar('calendar-range-endpoint-hover'),
  calendarRangeMiddle: cssVar('calendar-range-middle'),
  calendarDisabledDay: cssVar('calendar-disabled-day'),
  calendarActionHover: cssVar('calendar-action-hover'),
  btnSecondaryText: cssVar('btn-secondary-text'),
  btnSecondaryBorder: cssVar('btn-secondary-border'),
  btnSecondaryHoverBg: cssVar('btn-secondary-hover-bg'),
  btnSecondaryDisabledBorder: cssVar('btn-secondary-disabled-border'),
  btnSecondaryDisabledBg: cssVar('btn-secondary-disabled-bg'),
  btnSecondaryDisabledText: cssVar('btn-secondary-disabled-text'),
  btnGhostFocus: cssVar('btn-ghost-focus'),
  avatarBg: cssVar('avatar-bg'),
  avatarBgActive: cssVar('avatar-bg-active'),
  avatarText: cssVar('avatar-text'),
  logoSquare: cssVar('logo-square'),
  logoMark: cssVar('logo-mark'),
  toggleTrack: cssVar('toggle-track'),
  toggleThumbBg: cssVar('toggle-thumb-bg'),
  toggleThumbBorder: cssVar('toggle-thumb-border'),
  labelCardBg: cssVar('label-card-bg'),
  labelCardHover: cssVar('label-card-hover'),
  labelTitleAdded: cssVar('label-title-added'),
  labelTitleRemoved: cssVar('label-title-removed'),
  labelTitleSla: cssVar('label-title-sla'),
  labelTitleCustom: cssVar('label-title-custom'),
  calendarBg: cssVar('calendar-bg'),
  calendarDay: cssVar('calendar-day'),
  inputBorderSubtle: cssVar('input-border-subtle'),
  checkboxUnchecked: cssVar('checkbox-unchecked'),
  checkboxChecked: cssVar('checkbox-checked'),
  selectChevron: cssVar('select-chevron'),
  calendarIcon: cssVar('calendar-icon'),
  strokePrimary: cssVar('stroke-primary'),
  devicesPopupBg: cssVar('devices-popup-bg'),
  devicesHeaderBg: cssVar('devices-header-bg'),
  devicesSecondaryText: cssVar('devices-secondary-text'),
  devicesRowBorder: cssVar('devices-row-border'),
  devicesRowOddBg: cssVar('devices-row-odd-bg'),
  devicesRowHoverBg: cssVar('devices-row-hover-bg'),
  devicesInputBg: cssVar('devices-input-bg'),
  devicesSelectBorder: cssVar('devices-select-border'),
  devicesExclusionBtnBg: cssVar('devices-exclusion-btn-bg'),
  devicesEmptyCell: cssVar('devices-empty-cell'),
  btnTertiaryBg: cssVar('btn-tertiary-bg'),
  acaZerostateIcon: cssVar('aca-zerostate-icon'),
  frameworkCardBg: cssVar('framework-card-bg'),
  cardFillSecondary: cssVar('card-fill-secondary'),
  tabInactive: cssVar('tab-inactive'),
  analyzerBorder: cssVar('analyzer-border'),
  analyzerPanelDarker: cssVar('analyzer-panel-darker'),
  analyzerPanelBg: cssVar('analyzer-panel-bg'),
  analyzerChipText: cssVar('analyzer-chip-text'),
  analyzerMutedText: cssVar('analyzer-muted-text'),
  analyzerControlActive: cssVar('analyzer-control-active'),
  analyzerHighlight: cssVar('analyzer-highlight'),
  analyzerHighlightSoft: cssVar('analyzer-highlight-soft'),
  analyzerScrollbarTrack: cssVar('analyzer-scrollbar-track'),
  analyzerScrollbarThumb: cssVar('analyzer-scrollbar-thumb'),
  analyzerBarOdd: cssVar('analyzer-bar-odd'),
  analyzerBarEven: cssVar('analyzer-bar-even'),
  cardFillTertiary: cssVar('card-fill-tertiary'),
  cardFillQuaternary: cssVar('card-fill-quaternary'),
  analyzerFieldSelected: cssVar('analyzer-field-selected'),
  analyzerTheadBg: cssVar('analyzer-thead-bg'),
  analyzerIconActive: cssVar('analyzer-icon-active'),
  analyzerIconHover: cssVar('analyzer-icon-hover'),
  frameworkHover: cssVar('framework-hover'),
  frameworkCircleBg: cssVar('framework-circle-bg'),
  legacyGreyscale10: cssVar('legacy-greyscale-10'),
  legacyTextPrimary: cssVar('legacy-text-primary'),
  legacySecondary30: cssVar('legacy-secondary-30'),
  legacyWhite: cssVar('legacy-white'),
  legacySurface30: cssVar('legacy-surface-30'),
  legacyPrimaryLight: cssVar('legacy-primary-light'),
  legacyNeutral: cssVar('legacy-neutral'),
  legacy6c5b67: cssVar('legacy-6c5b67'),
  legacySecondary80: cssVar('legacy-secondary-80'),
  legacyBackgroundDark: cssVar('legacy-background-dark'),
  legacyAlpha1: cssVar('legacy-alpha-1'),
  legacyNeutral2: cssVar('legacy-neutral-2'),
  legacyPrimary70: cssVar('legacy-primary-70'),
  legacy2d2d3b: cssVar('legacy-2d2d3b'),
  legacyPrimaryLight2: cssVar('legacy-primary-light-2'),
  legacy2c242c: cssVar('legacy-2c242c'),
  legacy614964: cssVar('legacy-614964'),
  legacyPrimary40: cssVar('legacy-primary-40'),
  legacyAlpha2: cssVar('legacy-alpha-2'),
  legacy393038: cssVar('legacy-393038'),
  legacyControlBorder: cssVar('legacy-control-border'),
  legacyBorderLow: cssVar('legacy-border-low'),
  legacy372f35: cssVar('legacy-372f35'),
  legacy261f25: cssVar('legacy-261f25'),
  legacy261f252: cssVar('legacy-261f25-2'),
  legacyControlBorder2: cssVar('legacy-control-border-2'),
  legacyGreyscale50: cssVar('legacy-greyscale-50'),
  legacySurfaceContainerBackground: cssVar('legacy-surface-container-background'),
  legacy372e35: cssVar('legacy-372e35'),
  legacyWhite2: cssVar('legacy-white-2'),
  legacyNeutral3: cssVar('legacy-neutral-3'),
  legacy141218: cssVar('legacy-141218'),
  legacySurfaceContainerBackground2: cssVar('legacy-surface-container-background-2'),
  legacyBorderLow2: cssVar('legacy-border-low-2'),
  legacyPrimaryLight3: cssVar('legacy-primary-light-3'),
  legacyBorderLow3: cssVar('legacy-border-low-3'),
  legacyAlpha3: cssVar('legacy-alpha-3'),
  legacyTextPrimary2: cssVar('legacy-text-primary-2'),
  legacyPrimaryDarker: cssVar('legacy-primary-darker'),
  legacyBackgroundMedium: cssVar('legacy-background-medium'),
  legacy4e444b: cssVar('legacy-4e444b'),
  legacy292128: cssVar('legacy-292128'),
  legacyPrimary702: cssVar('legacy-primary-70-2'),
  legacyPrimary20: cssVar('legacy-primary-20'),
  legacyWhite3: cssVar('legacy-white-3'),
  legacyWhite4: cssVar('legacy-white-4'),
  legacyControlBorder3: cssVar('legacy-control-border-3'),
  legacyBackgroundDarker: cssVar('legacy-background-darker'),
  toggleInactiveBg: cssVar('toggle-inactive-bg'),
  overPerformanceIndicator: cssVar('over-performance-indicator'),
  initializingCardBg: cssVar('initializing-card-bg'),
  legacyToastShadow: cssVar('legacy-toast-shadow'),
  legacyChartTooltipShadow: cssVar('legacy-chart-tooltip-shadow'),
  legacySurfaceContainerBackground4: cssVar('legacy-surface-container-background-4'),
  legacyInfo10: cssVar('legacy-info-10'),
  legacyBackgroundDarker2: cssVar('legacy-background-darker-2'),
  legacyAlpha4: cssVar('legacy-alpha-4'),
  legacyPrimaryDark: cssVar('legacy-primary-dark'),
  legacySurfaceContainerBackground3: cssVar('legacy-surface-container-background-3'),
  legacyControlBorder4: cssVar('legacy-control-border-4'),
  legacySurfaceItemBackground: cssVar('legacy-surface-item-background'),
  legacy342f32: cssVar('legacy-342f32'),
  legacy483646: cssVar('legacy-483646'),
  legacyTextPrimary3: cssVar('legacy-text-primary-3'),
  legacy573f56: cssVar('legacy-573f56'),
  legacyNeutral100: cssVar('legacy-neutral100'),
  legacy573f562: cssVar('legacy-573f56-2'),
  legacy392b39: cssVar('legacy-392b39'),
  legacySurface50: cssVar('legacy-surface-50'),
  legacy6a5371: cssVar('legacy-6a5371'),
  legacySurfaceItemBackgroundLow: cssVar('legacy-surface-item-background-low'),
  legacyPrimaryDark2: cssVar('legacy-primary-dark-2'),
  legacySurface502: cssVar('legacy-surface-50-2'),
  legacy4e444b2: cssVar('legacy-4e444b-2'),
  legacyAlpha5: cssVar('legacy-alpha-5'),
  legacyAlpha6: cssVar('legacy-alpha-6'),
  legacySurface503: cssVar('legacy-surface-50-3'),
  legacy342f322: cssVar('legacy-342f32-2'),
  legacyAlpha7: cssVar('legacy-alpha-7'),
  legacy2921282: cssVar('legacy-292128-2'),
  legacyAlpha8: cssVar('legacy-alpha-8'),
  legacyFbd8f5: cssVar('legacy-fbd8f5'),
  legacy4836462: cssVar('legacy-483646-2'),
  legacySecondary802: cssVar('legacy-secondary-80-2'),
  legacyGreyscale102: cssVar('legacy-greyscale-10-2'),
  legacy573f563: cssVar('legacy-573f56-3'),
  legacy000000: cssVar('legacy-000000'),
  info: '#6abeed',
  warning: '#ffbc6c',
  infoLight: '#d3ceef',
  infoDark: '#b4Acfb',
  errorLight: '#f89b8e',
  warningLight: '#ffcc8e',
  primaryBorder: '#423d5c',
  secondaryDark: '#3f3b4d',
  rawSienneCore: '#f4ba94',
  purpleLight: '#e1bee7',
  purpleDark: '#23053a',
  neutral: cssVar('fg-neutral'),
  neutral100: cssVar('fg-neutral-100'),
  surfaceContainerBackground: cssVar('color-surfaceContainerBackground'),
  surfaceItemBackground: cssVar('surface-item-bg'),
  navBg: cssVar('nav-bg'),
  navBorder: cssVar('nav-border'),
  navText: cssVar('nav-text'),
  navTextSecondary: cssVar('nav-text-secondary'),
  navWordmark: cssVar('nav-wordmark'),
  navLogo: cssVar('nav-logo'),
  navItemHover: cssVar('nav-item-hover'),
  navItemActiveBg: cssVar('nav-item-active-bg'),
  navItemActiveFg: cssVar('nav-item-active-fg'),
  navSubItemBg: cssVar('nav-sub-item-bg'),
  avatarPlaceholderBg: cssVar('avatar-placeholder-bg'),
  chipNewBg: cssVar('chip-new-bg'),
  cpiChipBg: cssVar('cpi-chip-bg'),
  cpiChipText: cssVar('cpi-chip-text'),
  surfaceItemBackgroundLow: cssVar('color-surfaceItemBackgroundLow'),
  textPrimary: cssVar('fg-accent'),
  textSecondaryLow: cssVar('fg-secondary-low'),
  borderLow: cssVar('border-low'),
  borderMedium: cssVar('color-borderMedium'),
  controlBorder: cssVar('control-border'),
  hoverPrimary: cssVar('color-hoverPrimary'),
  charcoalPlum: '#4e444b',
  dustyRoseGray: cssVar('fg-dusty-rose'),
  mutedMauve: cssVar('fg-muted-mauve'),
  softMauve: cssVar('fg-soft-mauve'),
  deepCharcoalPlum: '#30282f',
  darkPlumTaupe: '#483646',
  blackenedPlum: '#3a2c3a',
  midnightPlum: '#392b39',
  smokyPlum: '#5c4757'
}

export const attributes = {
  boxShadow: {
    primary: '0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px rgba(0, 0, 0, 0.3)',
    secondary: '0 6px 10px 4px rgba(0, 0, 0, 0.15), 0 2px 3px rgba(0, 0, 0, 0.3)',
    tertiary: '0 4px 4px rgba(0, 0, 0, 0.25)',
    quaternary: '0 1px 3px 1px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.3)',
    toolbar: '0 2px 6px 2px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.3)',
    feedSection: '0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 4px 8px 3px rgba(0, 0, 0, 0.15)',
    chipCircle: '0 4px 4px 0 rgba(0, 0, 0, 0.3), 0 8px 12px 6px rgba(0, 0, 0, 0.15)',
    overallScoreWrapper: '0 1px 2px 0 rgba(0, 0, 0, 0.3), 0 1px 3px 1px rgba(0, 0, 0, 0.15)',
    selectFieldPaper: '0 8px 12px 6px rgba(0, 0, 0, 0.15), 0 4px 4px rgba(0, 0, 0, 0.3)',
    navigation: '0 4px 8px 0 #1e1a1d'
  },
  borderRadius: {
    primary: '20px',
    secondary: '8px',
    tertiary: '12px',
    quaternary: '16px',
    small: '4px',
    mediumSmall: '8px',
    normal: '24px',
    circle: '50%',
    large: '100px'
  }
}

export const typography = {
  fontSize: {
    xSmall: '8px',
    small: '10px',
    mediumSmall: '11px',
    medium: '12px',
    large: '14px',
    xLarge: '16px',
    header: '20px',
    xxLarge: '22px',
    xxxLarge: '24px',
    xxxxLarge: '28px',
    epic: '32px',
    huge: '45px'
  },
  fontWeight: {
    normal: 400,
    bold: 500,
    thin: 510,
    thick: 590,
    extraThick: 600
  },
  fontFamily: {
    primary: 'Quicksand, sans-serif',
    secondary: 'Rubick',
    tertiary: 'Source Sans Pro'
  }
}

export const theme = {
  colors,
  attributes,
  baseColors,
  baseUnit,
  iconSize,
  spacing,
  colorTokens,
  typography
}
